import { observer } from 'mobx-react-lite';
import {
  Dispatch,
  SetStateAction,
  SyntheticEvent,
  useEffect,
  useState,
} from 'react';
import {
  Button,
  Dropdown,
  Form,
  Menu,
  Modal,
  Select,
  Tab,
} from 'semantic-ui-react';
import {
  MetaDataElement,
  MetaDataOptions,
} from '../../../app/models/metaDataConfig';
import { store, useStore } from '../../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { Activity } from '../../../app/models/activity';
import { useParams } from 'react-router-dom';
import {
  VerifyInterface,
  optionsInterface,
  tabVerifyData,
} from '../../../app/models/tabverify';
import DashboardTemplateCard from '../../Dashboard/Receiving/CreateOrder/DashboardTemplateCard';
import {
  Communication,
  tempApi,
  Template,
  WorkflowElement,
  WorkflowOptions,
  WorkFlowSubTasks,
} from '../../../app/models/template';
import { OrderInitialState, Orders } from '../../../app/models/orders';
import { initialOrderReceiving } from '../../../app/models/itemOrderReceiving';
import agent from '../../../app/api/agent';
import { toast } from 'react-toastify';
import { SimpleHistoryReturn } from '../../../app/models/history';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { DeliveryRequest } from '../../../app/models/deliveryRequest';
import CreateOrderSaveFunction from '../../Dashboard/Receiving/CreateOrder/CreateOrderSaveFunction';
import { WorkLevel } from '../../../app/models/workLevel';
import VerifySaveFunction from '../../Dashboard/Receiving/VerifySaveFunction';

interface Props {
  title: string;
  setIsTableUpdated?: Dispatch<SetStateAction<boolean>>;
}
function SectionsModal({ title, setIsTableUpdated }: Props) {
  const modalStyle =
    title === 'sectionSingle'
      ? { height: '53vh', overflowY: 'scroll' }
      : { width: '40vw', margin: 'auto' };

  const {
    activityStore,
    userStore,
    dashboardStore,
    WorkLevelStore,
    TemplateStore,
    mediaAssetStore,
    departmentStore,
    commonStore,
  } = useStore();
  const { departmentRegistry, loadDepartments, departmentitemsByDate } =
    departmentStore;
  const {
    loadWorkLevelBasedOnItemLevel,
    workLevelitemsByDateAll,
    loadWorkLevels,
    workLevelRegistryAll,
    loadWorkLevel,
  } = WorkLevelStore;
  const { loadTemplateIdForCR, selectedTemplate, loadAssetTypeById } =
    TemplateStore;
  const { assetTypeRegistry, loadAssetTypes } = TemplateStore;
  const { selectedActivity: activity } = activityStore;

  const { id } = useParams<{ id: string }>();
  const [form, setForm] = useState({
    AssetName: '',
    Worklevel: '',
    Type: '',
    Element: '',
    Department: '',
    Template: '',
  });
  const { assetTypesByName, selectedAssetType } = TemplateStore;
  const [elementTypeOptions, setElementTypeOptions] = useState<
    optionsInterface[] | []
  >([]);
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState<string>(''); //parent selection
  const [orderState, setOrderState] = useState<Orders>(OrderInitialState);
  const [element, setElement] = useState<string>('');
  const [elementName, setElementName] = useState<string>('');
  const [typeSearch, setTypeSearch] = useState<string>('');
  const [templateSelected, SetTemplateSelected] = useState<
    Template | undefined
  >(selectedTemplate);
  const [departmentSelected, setDepartmentSelected] = useState('');
  const [departmentClear, setDepartmentClear] = useState('');
  const [subChildObj, setSubChildObj] = useState<VerifyInterface[]>([]);
  const [elementType, setElementType] = useState('');
  const [itemLevel, setItemLevel] = useState<Activity | undefined>();
  const [deliveryData, setDeliveryData] = useState<
    DeliveryRequest | undefined
  >();
  const [restrictSubmit, setRestrictSubmit] = useState(false);
  const [submitTemplate, setSubmitTemplate] = useState(false);
  const [loaing, setLoading] = useState(false);
  const isSingleSection = title === 'sectionSingle';

  const isValid = isSingleSection
    ? form.AssetName &&
      form.Type &&
      form.Element &&
      form.AssetName.replace(/\s/g, '')
    : form.AssetName &&
      form.Type &&
      form.Element &&
      form.Worklevel &&
      form.AssetName.replace(/\s/g, '');

  const filteredKeyValue = (data: any) => {
    return data.options.filter((item: any) => data.value === item.value)[0].key;
  };
  const filteredTemplate =
    TemplateStore?.selectedElementTypes?.templateTypes.filter(
      (x) =>
        !!dashboardStore.dashboard.selectedUserRoleId.includes(x.templateId),
    );
  const templateoptions = filteredTemplate?.map((x: any) => ({
    key: x.templateId + '/' + x.templateName,
    text: x.templateName,
    value: x.templateName,
  }));
  const filteredDepartment = departmentitemsByDate.filter((x: any) =>
    dashboardStore.dashboard.selectedUserRoleId.includes(x.id),
  );
  const departmentSet = new Set<string>();
  filteredDepartment.forEach((x) => {
    departmentSet.add(x.department_Name);
  });
  const departmentoptions = Array.from(departmentSet).map((departmentName) => {
    const item = filteredDepartment.find(
      (x) => x.department_Name === departmentName,
    );
    return {
      key: item!.id + '/' + item!.department_Name,
      text: item!.department_Name,
      value: item!.id,
    };
  });
  const workleveloptions = workLevelitemsByDateAll.map((x) => ({
    key: x.id,
    text: x.title,
    value: x.id,
  }));
  const assetTypeOptions = assetTypesByName?.map((x) => ({
    key: x?.id + '/' + x.typeName,
    text: x?.typeName,
    value: x.id,
  }));
  useEffect(() => {
    setForm({ ...form });
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (workLevelRegistryAll.size <= 1) loadWorkLevels();
    // eslint-disable-next-line
  }, [workLevelRegistryAll.size, loadWorkLevels]);

  useEffect(() => {
    if (restrictSubmit) return;
    if (assetTypeRegistry.size <= 1) loadAssetTypes();
    // eslint-disable-next-line
  }, [assetTypeRegistry.size, loadAssetTypes]);
  useEffect(() => {
    let activity = activityStore.activeTask;
    setTypeSearch('');
    if (activity) {
      setItemLevel(activity);
      if (activity?.elementtypeid !== undefined) {
        TemplateStore.loadElementTypeById(activity?.elementtypeid);
      }
      if (activity?.itemDeliveryRequest) {
        setDeliveryData(
          activity?.itemDeliveryRequest?.filter(
            (i) => i.isActive === true,
          )?.[0],
        );
      } else {
        setDeliveryData(undefined);
      }
    }
    // eslint-disable-next-line
  }, [activityStore.activeTask]);

  //////////////  Selected Template UseEffect
  useEffect(() => {
    if (selectedTemplate && submitTemplate) {
      const NewIdGenerate = uuid();
      const temp = {
        ...selectedTemplate,
        tasks: [...selectedTemplate.tasks],
      };
      temp.templateId = NewIdGenerate;
      temp.tasks.forEach((task: any) => {
        task.taskId = uuid();
        task.isCurrentTask = false;

        task?.subTasks?.forEach((subtasks: WorkFlowSubTasks) => {
          subtasks.subTaskId = uuid();
          subtasks.isCurrentSubtask = false;
          subtasks.communication.forEach((communication: Communication) => {
            communication.id = uuid();
          });
          subtasks.api.forEach((tempApi: tempApi) => {
            tempApi.id = uuid();
          });
          subtasks.elements.forEach((element: WorkflowElement) => {
            element.elementId = uuid();
            element.options.forEach((options: WorkflowOptions) => {
              options.optionId = uuid();
            });
          });
        });
      });
      dashboardStore.updateCreateOrderTemplate(temp);
      SetTemplateSelected(temp);
      if (!itemLevel && form.Template) return;
      const customerId = userStore.user?.customerName as string;
      let newArr = {
        ...orderState,
        isActive: true,
        customerId: customerId,
        departmentId: departmentClear.split('/')[0],
      };
      store.dashboardStore.dashboard.L2CardValueInventory = 'Receiving';
      CreateOrderSaveFunction(
        itemLevel,
        newArr,
        deliveryData,
        'sectionModel',
        setIsTableUpdated,
        closeForm,
        setLoading,
      );
      setSubmitTemplate(false);
    }
    // eslint-disable-next-line
  }, [selectedTemplate, itemLevel, submitTemplate]);

  useEffect(() => {
    if (id) {
      loadWorkLevelBasedOnItemLevel(id);
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (departmentRegistry.size <= 1) loadDepartments();
  }, [departmentRegistry.size, loadDepartments]);

  useEffect(() => {
    if (selectedAssetType) {
      const elementTypeOptions2 = selectedAssetType?.elementTypes.map((x) => ({
        key:
          x.id +
          '/' +
          selectedAssetType.typeName +
          '/' +
          x.elementName +
          '/' +
          selectedAssetType.id,
        text: x.elementName,
        value: x.id,
      }));
      setElementTypeOptions(elementTypeOptions2);
    }
  }, [selectedAssetType, form.Type]);
  useEffect(() => {
    setTimeout(() => {
      const subObj = {
        ...tabVerifyData,
        parentPane: selectedAssetTypeId.split('/')[1],
        childPane: elementType,
        number_of_elem: '',
        typeid: elementType.split('/')[3],
        photos: [],
        files: [],
        // registerId: dashboardStore.dashboard.checkClikedWorkLevelId,
      };
      const updatedSubChildObj = subChildObj.filter(
        (item) => item.childPane !== elementType,
      );
      setSubChildObj([...updatedSubChildObj, subObj]);
    }, 250);
    // eslint-disable-next-line
  }, [form.Element]);
  useEffect(() => {
    if (selectedTemplate) {
      SetTemplateSelected(selectedTemplate);
      dashboardStore.updateCreateOrderTemplate(selectedTemplate);
    }
    // eslint-disable-next-line
  }, [selectedTemplate]);

  const deptSelect = (e: any, data: any) => {
    setForm({
      ...form,
      Department: data.value,
    });
    if (data.value === '') setForm({ ...form, Department: '', Template: '' });

    if (data.name === 'customerId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderClientId = data.value;
      }
    }
    if (data.name === 'departmentId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderDepartmentId = data.value;
        setDepartmentSelected(e.target.textContent);

        activityStore.createOrderDepartmentName = e.target.textContent;
        setDepartmentClear(data.value);
      } else {
        setDepartmentSelected('');
        setDepartmentClear('');
      }
    }
  };

  const handleParentDropdown = (e: any, data: any) => {
    setForm({
      ...form,
      Type: data.value,
      Element: '',
      Template: '',
    });
    const tempValue = filteredKeyValue(data);
    setSelectedAssetTypeId(tempValue); //parent
    setTypeSearch('');
    SetTemplateSelected(undefined);
    dashboardStore.updateCreateOrderTemplate(undefined);
  };
  const handleSave = async () => {
    setLoading(true);
    setRestrictSubmit(true);
    new Promise(async (resolve) => {
      const response = await agent.WorkLevels.loadName(
        store.dashboardStore.dashboard.dashboardWorkLevelMaster.id,
      );
      resolve(response);
    })
      .then(async (response) => {
        const lastArraysubObj = subChildObj[subChildObj.length - 1];
        const metaDataDetails =
          await agent.ElementTypes.getElementTypeMetaDataTemplate(
            lastArraysubObj.childPane.split('/')[0],
          );
        lastArraysubObj.metadata = metaDataDetails[0].metadata || [];

        let newArr = {
          title: form.AssetName,
          department: departmentClear,
          typeSearch,
          templateSelected,
        };
        setTimeout(async () => {
          await VerifySaveFunction(subChildObj, response, newArr);
        }, 100);
        const delay = typeSearch ? 4500 : 1000;
        setTimeout(async () => {
          typeSearch && setSubmitTemplate(true);
          if (!typeSearch) {
            setIsTableUpdated?.(true);
            closeForm();
            setLoading(false);
          }
        }, delay);
      })
      .catch((error) => {
        console.error('Error in promise chain:', error);
      });
  };

  const handleSelect = (e: SyntheticEvent, data: any) => {
    //set create order
    setForm({
      ...form,
      Template: data.value,
    });
    const tempValue = filteredKeyValue(data);
    if (data.value === '') {
      setTypeSearch('');
      setOrderState(OrderInitialState);
      dashboardStore.updateCreateOrderTemplate(undefined);
      SetTemplateSelected(undefined);
    } else {
      setTypeSearch(tempValue);
      loadTemplateIdForCR(tempValue.split('/')[0]);
      store.TemplateStore.loadingTemplate = true;
      const oldArr = {
        ...orderState,
        templateId: tempValue,
      };
      setOrderState(oldArr);
    }
  };

  const handleDropDownSelect = (e: SyntheticEvent, data: any) => {
    setForm({
      ...form,
      Worklevel: data.value,
    });
    if (data.value === '') {
      loadWorkLevel(data.value);
      store.WorkLevelStore.selectedworkLevel = undefined;
    } else {
      const datas: WorkLevel | undefined = workLevelRegistryAll.get(data.value);
      if (datas !== undefined) {
        store.WorkLevelStore.selectedworkLevel = datas;
        dashboardStore.setWorkLevelMaster(datas);
      }
    }
  };

  useEffect(() => {
    if (selectedAssetTypeId !== '')
      loadAssetTypeById(selectedAssetTypeId.split('/')[0]);
    TemplateStore.loadElementTypeById(element);
    // eslint-disable-next-line
  }, [selectedAssetTypeId, element]);

  const handleClone = async () => {
    // if(dashboardStore.dashboard.CreateOrderTemplate){
    const FilmArray: string[] = [];
    const response = await agent.WorkLevels.loadName(
      store.dashboardStore.dashboard.dashboardWorkLevelMaster.id,
    );
    response.forEach((x) => FilmArray.push(x.title));
    const items: Activity[] = [];
    const generatedID = uuid();

    activity?.metadata?.forEach((MetaDataElement: MetaDataElement) => {
      MetaDataElement.elementId = uuid();
      MetaDataElement.options.forEach((metadataOptions: MetaDataOptions) => {
        metadataOptions.optionId = uuid();
      });
    });
    let itemDataOrders: any = dashboardStore.dashboard.CreateOrderTemplate;
    if (itemDataOrders) {
      itemDataOrders.templateId = uuid();
      itemDataOrders.tasks.forEach((task: any) => {
        task.taskId = uuid();
        task.isCurrentTask = false;
        task?.subTasks?.forEach((subtasks: WorkFlowSubTasks) => {
          subtasks.subTaskId = uuid();
          subtasks.isCurrentSubtask = false;
          subtasks.communication.forEach((communication: Communication) => {
            communication.id = uuid();
          });
          subtasks.api.forEach((tempApi: tempApi) => {
            tempApi.id = uuid();
          });
          subtasks.elements.forEach((element: WorkflowElement) => {
            element.elementId = uuid();
            element.options.forEach((options: WorkflowOptions) => {
              options.optionId = uuid();
            });
          });
        });
      });
      // let currentTaskData = '';
      // let currentSubTaskData = '';
      for (let i = 0; i < itemDataOrders.tasks?.length; i++) {
        //setting the current task and subtask
        if (itemDataOrders.tasks[i].isActive === true) {
          itemDataOrders.tasks[i].isCurrentTask = true;
          // currentTaskData = itemDataOrders.tasks[i].taskName;
          const subtaskDetail = itemDataOrders.tasks[i].subTasks;
          for (let i = 0; i < subtaskDetail.length; i++) {
            if (subtaskDetail[i].isActive === true) {
              subtaskDetail[i].isCurrentSubtask = true;
              // currentSubTaskData = subtaskDetail[i].subTaskName;
              break;
            }
          }
          break;
        }
      }
      // if (currentSubTaskData) {
      //   let payload = {
      //     id: generatedID,
      //     current_user: store.userStore.user?.username,
      //     status: 'Yet to Start',
      //     current_task: currentTaskData,
      //     current_subtask: currentSubTaskData,
      //     isReceiving: true,
      //   };
      //   setTimeout(async () => {
      //     await agent.workflowStatus.updateWorkflowStatus(payload);
      //   }, 1000);
      // }
    }
    const updateData = {
      ...orderState,
      orderId: uuid(),
      orderDateTime: store.activityStore.updateDateTime(),
      isReceiving: true,
      isDelivery: false,
      isReturn: false,
      username:
        store.userStore.user?.username !== undefined
          ? store.userStore.user.username
          : '',
      isActive: true,
      itemOrderReceiving: [
        {
          ...initialOrderReceiving,
          id: uuid(),
          receivingId: activity?.id,
          isActive: true,
          customerId: orderState.customerId,
          departmentId: orderState.departmentId,
          receivingWorkflows: [dashboardStore.dashboard.CreateOrderTemplate],
        },
      ],
    };

    const sectionsFromID = activity?.id + '/' + activity?.title;
    let IncFilmName = form.AssetName;
    const toCheck = (name: string) => {
      // Recursion Function to append name
      if (FilmArray?.includes(name)) {
        let incVal = name?.split('~')[1]; //"11"
        const toint = parseInt(incVal) + 1; //12
        incVal = toint?.toString(); //"12"
        IncFilmName = IncFilmName?.split('~')[0] + '~' + incVal; //test+"12" - "test12"
        toCheck(IncFilmName); //calling recursion again
        return IncFilmName;
      }
      FilmArray.push(IncFilmName);
      return IncFilmName;
    };
    toCheck(IncFilmName);
    activityStore.loadingInitialSections = true;
    const item: any = {
      ...activity,
      id: generatedID,
      title: IncFilmName,
      asset_tracking_status: dashboardStore.dashboard.CreateOrderTemplate
        ? 'Receiving Order Created'
        : 'New Asset Titles Added This Month',
      order_tracking: '',
      departmentId: departmentClear.split('/')[0],
      departmentName: departmentSelected,
      files: [],
      type: activity?.type,
      elementtypeid: element,
      element: elementName,
      physical_sensor_barcode: generatedID,
      physical_sensor_rfid: generatedID,
      physical_sensor_qrcode: generatedID,
      receivingdate: new Date().toISOString(),
      itemCreatedAt: new Date().toISOString(),
      last_modified: new Date().toISOString(),
      movementdate: new Date().toISOString(),
      maintenance: new Date().toISOString(),
      status_Time: new Date().toISOString(),
      isReceivingOrder: dashboardStore.dashboard.CreateOrderTemplate
        ? true
        : false,
      isReceiving: dashboardStore.dashboard.CreateOrderTemplate ? true : false,
      assignedUsers: [
        {
          appUserId: userStore.user?.id,
          itemLevelId: generatedID,
          isHost: true,
        },
      ],
      itemHistory: [
        SimpleHistoryReturn(
          IncFilmName,
          `from ${activity?.title}`,
          generatedID,
        ),
      ],
      inwards: [],
      comments: [],
      itemDeliveryRequest: [],
      orders: dashboardStore.dashboard.CreateOrderTemplate ? [updateData] : [],
      receivings: [],
      metadata: activity?.metadata,
      parent: sectionsFromID,
    };
    item?.metadata?.forEach((_data: any, i: number) => {
      item.metadata[i].id = uuid();
      item.metadata[i]?.options?.forEach((_data: any, j: number) => {
        item.metadata[i].options[j].optionId = uuid();
      });
    });
    items.push(item);

    if (dashboardStore.dashboard.dashboardWorkLevelMaster.id !== undefined) {
      const HistoryArr2: any = {
        id: activity!.id,
        itemHistory: [
          SimpleHistoryReturn(
            items[0].title,
            `from ${activity?.title}`,
            activity!.id,
          ),
        ],
      };
      const data: any = {
        ...dashboardStore.dashboard.dashboardWorkLevelMaster,
        items,
      };

      try {
        let promise = new Promise(async (resolve) => {
          activityStore.updateItemLevelSections(
            data,
            activity!.id + '/' + activity!.title,
            HistoryArr2,
          );
          resolve('');
        });
        promise.then(async () => {
          let activetasks = itemDataOrders?.tasks?.filter(
            (data: { isActive: string }) => data.isActive,
          );
          await agent.WorkLevels.updateProductionCountViaSections(
            activetasks?.length || 0,
          );
          agent.Activities.onlyHistory(items[0].id, HistoryArr2); //for Parent
          activityStore.loadSectionsData = `${1}/${1}`;
          toast.success('Item Created Succesfully.');
        });
        promise.catch(() => {
          store.activityStore.loadingInitialSections = false;
        });
      } catch {}
      // }
    }

    agent.Reports.metadataHeadersPostItemID(generatedID); //To Update MetaData Header Table
    mediaAssetStore.mediaAsset.openSectionSingle = false;
    activityStore.loadingInitialSections = false;
    dashboardStore.updateCreateOrderTemplate(undefined);
    SetTemplateSelected(undefined);
    loadTemplateIdForCR('');
    setTypeSearch('');
  };

  const elementDropdownChange = (e: any, data: any) => {
    setForm({
      ...form,
      Element: data.value,
      Template: '',
    });
    const TempValue = filteredKeyValue(data);
    setElementType(TempValue);
    // setFilmTitleElement(data.value.split("/")[2])
    setElement(TempValue.split('/')[0]);
    setElementName(TempValue.split('/')[2]);

    setTypeSearch('');
    SetTemplateSelected(undefined);
    dashboardStore.updateCreateOrderTemplate(undefined);
  };

  const CloseModal = () => {
    mediaAssetStore.mediaAsset.openSectionSingle = false;
    SetTemplateSelected(undefined);
    dashboardStore.updateCreateOrderTemplate(undefined);
    setSelectedAssetTypeId('');
    setElement('');
    closeForm();
  };
  const closeForm = () => {
    setRestrictSubmit(false);
    setElementTypeOptions([]);
    setForm({
      ...form,
      AssetName: '',
      Worklevel: '',
      Type: '',
      Element: '',
      Department: '',
      Template: '',
    });
  };
  const panes = [
    {
      menuItem: 'Template',
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <Menu>
            <Dropdown
              placeholder="Template Type"
              fluid
              selection
              options={templateoptions}
              search
              onChange={handleSelect}
              value={form.Template}
            />
          </Menu>
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Customization',
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <DashboardTemplateCard templateSelected={templateSelected} />
        </Tab.Pane>
      ),
    },
  ];
  const buttonRender = () => {
    return (
      <>
        <Button.Group>
          <Button onClick={CloseModal}>
            {title === 'sectionSingle' ? 'Close' : 'Cancel'}
          </Button>
          <Button.Or />
          <Button
            color="blue"
            disabled={!isValid}
            loading={loaing}
            // disabled={!(filmname.length && element.length && intialSearch.length && departmentClear.length)}
            onClick={() =>
              title === 'sectionSingle' ? handleClone() : handleSave()
            }
          >
            {title === 'sectionSingle' ? 'Create' : 'Save'}
          </Button>
        </Button.Group>
      </>
    );
  };

  const sectionModel = () => {
    return (
      <>
        <Modal.Content style={modalStyle}>
          <Form>
            {title !== 'sectionSingle' && (
              <Form.Field
                fluid
                control={Select}
                name="WorkLevel"
                placeholder={'Select/Create WorkLevel'}
                options={workleveloptions}
                onChange={handleDropDownSelect}
                value={form.Worklevel}
              />
            )}
            <Form.Field>
              <input
                placeholder="Asset Name"
                value={form.AssetName}
                onChange={(e) =>
                  setForm({
                    ...form,
                    AssetName: e.target.value,
                  })
                }
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Field
                fluid
                control={Select}
                name="name"
                placeholder="Type"
                options={assetTypeOptions}
                onChange={handleParentDropdown}
                value={form.Type}
              />
              <Form.Field
                fluid
                control={Select}
                name="Element"
                placeholder="Element"
                options={elementTypeOptions}
                onChange={elementDropdownChange}
                value={form.Element}
              />
            </Form.Group>
            <Dropdown
              fluid
              search
              required
              selection
              clearable
              options={departmentoptions}
              name="departmentId"
              value={form.Department}
              placeholder={
                (
                  userLanguage[0].Level3InventoryRecievingCreateOrder
                    ?.IRCODD01 as any
                )?.[`${commonStore.language.key}`]
              } //"Select Department"
              onChange={deptSelect}
            />
          </Form>
          {(title === 'sectionSingle' || form.Department) && (
            <Tab style={{ marginTop: '20px' }} panes={panes} />
          )}
        </Modal.Content>
        <Form.Group
          widths="equal"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div></div>
          <div
            style={
              title === 'sectionSingle'
                ? { float: 'right', marginBottom: '10px', marginRight: '10px' }
                : {}
            }
          >
            <br /> {buttonRender()}
          </div>
        </Form.Group>
      </>
    );
  };

  if (title === 'sectionSingle') {
    return (
      <Modal
        onClose={() => mediaAssetStore.setOpenSectionsSingle(false)}
        onOpen={() => mediaAssetStore.setOpenSectionsSingle(true)}
        open={mediaAssetStore.mediaAsset.openSectionSingle}
      >
        <Modal.Header>Sections Single</Modal.Header>
        {sectionModel()}
      </Modal>
    );
  } else {
    return <div className="new-report-form-wrapper">{sectionModel()}</div>;
  }
}

export default observer(SectionsModal);
